<template>
  <div id="app">
    <router-view />
  </div>
</template>


<style lang="scss">
html, body {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}

#app {
  width: 100vw;
  height: 100vh;
  background-color: #020308;
  overflow: hidden;
  position: relative;
}
</style>
